import LoadingSpinner from "./Visuals";
import { Alert } from "react-bootstrap";
import { RowRenderer } from "./RowRenderer";
import React, { useState } from "react";


export function TableBody({ rows, updateRefresh, upTrend, mobile }) {
    const [loading, setLoading] = useState(false)

    return (
        <tbody>
            {
                loading
                    ?
                    (<LoadingSpinner />)
                    :
                    rows === false
                        ?
                        (
                            <div dir="rtl" className="d-flex justify-content-center">
                                <Alert variant="danger" className="justify-content-center">
                                    <Alert.Heading>خطای ارتباط با سرور</Alert.Heading>
                                    <button className="btn btn-sm btn-warning" onClick={() => {
                                        setLoading(true)
                                        setInterval(() => {
                                            setLoading(false)
                                        }, 2000);
                                        updateRefresh()
                                    }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="#0c0000" strokeWidth="2" strokeLinecap="round"
                                            strokeLinejoin="round">
                                            <path
                                                d="M21.5 2v6h-6M2.5 22v-6h6M2 11.5a10 10 0 0 1 18.8-4.3M22 12.5a10 10 0 0 1-18.8 4.2" />
                                        </svg>
                                    </button>
                                </Alert>
                            </div>
                        )
                        :
                        (<RowRenderer mobile={mobile} upTrend={upTrend} />)
            }
        </tbody>
    )
}